import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import * as _ from "lodash";
import moment from "moment";
import { takeUntil, switchMap } from "rxjs/operators";
import { Subject, Subscriber, Observable } from "rxjs";
import { NbcLoggerService } from "../../shared/logger/nbc-logger.service";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { ContactService } from "../../shared/services/contact.service";
import { ContactSharedDataService } from "../contact-shared.service";
import { EmployeeTypeService } from "../../shared/services/employeetype.service";
import { PermissionUtility } from "../../core/services/permission-utility.service";
import { SharedDataService } from "../../shared/sharedData.service";
import { SkillsService } from "../../shared/services/skills.service";
import { PositionService } from "../../shared/services/position.service";

@Component({
    templateUrl: "./contact-details.component.html",
    standalone: false
})
export class ContactDetailsComponent implements OnInit {
    constructor(
        private _contactService: ContactService,
        private _contactSharedData: ContactSharedDataService,
        private _employeeTypeService: EmployeeTypeService,
        private _router: Router,
        private _activatedRoute: ActivatedRoute,
        private _dataService: SharedDataService,
        public _modalService: BsModalService,
        private _skillService: SkillsService,
        private _positionService: PositionService,
        private log: NbcLoggerService
        //private _cd: ChangeDetectorRef
    ) {}

    editMode = false;
    noEditMode = false;
    showSyncMessage: any | undefined;
    employeeTypes: {} | undefined;
    rateCardList: any[] | undefined;
    submitted = false;
    mode = "";
    disableCancel = false;
    unionOptions: any;
    contactCopy: any;
    preload = {
        mode: "",
    };
    editModeHRVerifiedSection = false;
    currentUser: any = window.preload.user;
    componentDestroyed$: Subject<boolean> = new Subject();
    contactId: number | undefined;
    contact: any | undefined;
    countries: any;
    skillSearchTerm = "";
    skillData: any[] = [];
    positionSearchTerm = "";
    positionObservable$: Observable<any[]> | undefined;

    tabs = [
        {
            heading: "Profile Info",
            route: "profileinfo",
            active: true,
            hasAccess: false,
            authentication:
                "contact.retrieve,contact.hrmaster.retrieve,contact_profile_profile_info.retrieve",
        },
        {
            heading: "Work History",
            route: "workhistory",
            active: false,
            hasAccess: false,
            authentication:
                "contact.workhistory.retrieve,contact_profile_work_history.retrieve",
        },
        {
            heading: "Work Schedule",
            route: "workschedule",
            active: false,
            hasAccess: false,
            authentication:
                "contact.workschedule.retrieve,contact.workschedule.create,contact_profile_work_schedule.retrieve",
        },
        {
            heading: "Work Schedule ALL",
            route: "workscheduleall",
            active: false,
            hasAccess: false,
            authentication:
                "contact.workschedule.retrieve,contact.workschedule.create,contact_profile_work_schedule.retrieve",
        },
    ];

    setEditMode(callFromComponent?: boolean) {
        this.log.trace("setEditMode");
        this.editMode = true;

        this.contactCopy = _.cloneDeep(this.contact);
        if (!callFromComponent) {
            setTimeout(() => {
                this._contactSharedData.isContactEditModeEnabled(true);
            }, 100);
        }
        // this.getRateCards();
        //this.setDialCode(1);
    }

    loadContactDetails(showSyncMsg) {
        this.log.trace("loadContactDetails");
        // Vars
        this.showSyncMessage = showSyncMsg;
        this.editMode = false;
        this.employeeTypes = {};
        this.rateCardList = [];
        this.submitted = false;
        if (this.preload.mode) {
            if (
                this.preload.mode === "newSync" ||
                this.preload.mode === "newNoSync" ||
                this.preload.mode === "newNoSyncError" ||
                this.preload.mode === "newCancelSync" ||
                this.preload.mode === "newNoSyncSSNError" ||
                this.preload.mode === "newNoSyncSSOError"
            ) {
                this.mode = "new";
            } else {
                this.mode = this.preload.mode;
            }
        } else {
            this.mode = "";
        }
        this.disableCancel = false;
        this.unionOptions = [
            {
                name: "Union",
            },
            {
                name: "Non union",
            },
        ];
        this.contact = {};
        this.contactCopy = {};
        // Initialize
        this.contact = this.getContact();
        this.getEmployeeTypes();
    }

    getEmployeeTypes() {
        this.log.trace("contact Details -> getEmployeeType:fetching data");
        this._employeeTypeService
            .getAllEmployeeTypes()
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe(
                (data) => {
                    this.employeeTypes = data.reference;
                    this.log.trace("contact Details -> EmployeeType received");
                },
                (err) => this.log.error(err),
                () => {}
            );
    }

    // Get Contact

    getContact() {
        //var defer = $q.defer();
        this.log.trace("retrieve contact");

        this._contactService
            .getContact(this.contactId)
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe(
                (data) => {
                    this.log.trace("contactSearch -> search received");
                    this.contact = data.reference;
                    this.contactCopy = _.cloneDeep(this.contact);
                    if (
                        this.preload.mode === "newNoSync" &&
                        this.showSyncMessage
                    ) {
                        this.log.showError(
                            "No results found. This contact will be added with only the details you have entered.  Incorrect or dummy data will prevent the contact from syncing with SAP."
                        );
                    }
                    if (
                        this.preload.mode === "newNoSyncError" &&
                        this.showSyncMessage
                    ) {
                        this.log.showError(
                            "Unable to sync contact at this time."
                        );
                    }
                    if (
                        this.preload.mode === "newCancelSync" &&
                        this.showSyncMessage
                    ) {
                        this.log.showError(
                            "This contact will be added with only the details you have entered.  Incorrect or dummy data will prevent the contact from syncing with SAP."
                        );
                    }
                    if (
                        this.preload.mode === "newSync" &&
                        this.showSyncMessage
                    ) {
                        this.log.showSuccess("Contact synced successfully.");
                    }
                    if (
                        this.preload.mode === "newNoSyncSSNError" &&
                        this.showSyncMessage
                    ) {
                        this.log.showError(
                            "There is an existing contact with the same birthday, last four digits of the social security number and last name.  You cannot create a duplicate contact.  Please cancel this request."
                        );
                    }
                    if (
                        this.preload.mode === "newNoSyncSSOError" &&
                        this.showSyncMessage
                    ) {
                        this.log.showError(
                            "There is an existing contact with this SSO. You cannot have more than one contact with the same SSO."
                        );
                    }
                    this.showSyncMessage = false;
                    this.setDialCode(1);
                    this.setDialCode(2);
                    this.setDialCode(3);

                    this.getRateCards();
                    this.setDefaultContactCustomColor();

                    this._contactSharedData.setContact(this.contact);

                    if (this.mode === "edit" || this.mode === "new") {
                        this.setEditMode(false);
                    }
                    if (this.mode === "new") {
                        this.disableCancel = true;
                    }
                },
                (err) => this.log.error(err),
                () => {}
            );
    }

    setDialCode(seqnumber) {
        if (this.contact) {
            switch (seqnumber) {
                case 1:
                    this.contact.phone1.dialCode = this.getCountryDialCode(
                        this.contact.phone1.countryCode
                    );
                    break;
                case 2:
                    this.contact.phone2.dialCode = this.getCountryDialCode(
                        this.contact.phone2.countryCode
                    );
                    break;
                case 3:
                    this.contact.phone3.dialCode = this.getCountryDialCode(
                        this.contact.phone3.countryCode
                    );
                    break;
            }
        }
    }

    onEmployeeTypeChange() {
        this.contact.rateCode = {};
        this.getRateCards();
        this.checkRateCode();
    }

    checkRateCode() {
        this.log.trace("chceking Rate Code");
        if (this.contact.employeeType.description === "Select One") {
            this.contact.rateCode.id = "";
            this.contact.rateCode.description = "";
        } else if (
            this.contact.employeeType.description.toLowerCase() === "vendor"
        ) {
            this.contact.rateCode.id = "";
            this.contact.rateCode.description = "N/A";
        }
    }

    getCountryDialCode(IsoCode) {
        let dialcode;
        if (this.countries) {
            for (let i = 0; i < this.countries.length; i++) {
                if (this.countries[i].isoCode === IsoCode) {
                    dialcode = this.countries[i].dialCode;
                }
            }
        }

        return dialcode;
    }

    getRateCards() {
        if (
            this.contact &&
            this.contact.employeeType &&
            this.contact.employeeType !== "" &&
            this.contact.employeeType.description.toLowerCase() !== "vendor"
        ) {
            this.rateCardList = this.contact.employeeType.rateCards;
        } else if (
            this.contact &&
            this.contact.employeeType &&
            (this.contact.employeeType === "" ||
                this.contact.employeeType.description.toLowerCase() ===
                    "vendor")
        ) {
            this.contact.rateCode.id = undefined;
            this.contact.rateCode.description = "";
            this.rateCardList = [];
        }
    }

    setDefaultContactCustomColor() {
        if (this.contact && this.contact.contactVerified) {
            this.contact.contactVerified.tooltip = this.contact.contactVerified
                .fieldBool
                ? "Contact Information Accurate"
                : "Contact Information May Not Be Accurate";
            if (this.contact.contactVerified.updatedBy != "") {
                this.contact.contactVerified.modifiedDate = moment
                    .utc(this.contact.contactVerified.updatedDate)
                    .format("MM/DD/YYYY");
                this.contact.contactVerified.tooltip =
                    this.contact.contactVerified.tooltip +
                    (this.contact.contactVerified.updatedBy
                        ? "\nVerified By: " +
                          this.contact.contactVerified.updatedBy +
                          " Verified On: " +
                          this.contact.contactVerified.modifiedDate
                        : "");
            }
            this.contact.contactVerified.color = this.contact.contactVerified
                .fieldBool
                ? "Green"
                : "Red";
        }
        if (this.contact && this.contact.covidCommunicationSent) {
            this.contact.covidCommunicationSent.tooltip = this.contact
                .covidCommunicationSent.fieldBool
                ? "Notification Email Sent"
                : "Notification Email Not Sent";
            if (this.contact.covidCommunicationSent.updatedBy != "") {
                this.contact.covidCommunicationSent.modifiedDate = moment
                    .utc(this.contact.covidCommunicationSent.updatedDate)
                    .format("MM/DD/YYYY");
                this.contact.covidCommunicationSent.tooltip =
                    this.contact.covidCommunicationSent.tooltip +
                    (this.contact.covidCommunicationSent.updatedBy
                        ? "\nSent By: " +
                          this.contact.covidCommunicationSent.updatedBy +
                          " Sent On: " +
                          this.contact.covidCommunicationSent.modifiedDate
                        : "");
            }
            this.contact.covidCommunicationSent.color = this.contact
                .covidCommunicationSent.fieldBool
                ? "Green"
                : "Red";
        }
        if (this.contact && this.contact.covidReplyRecd) {
            this.contact.covidReplyRecd.tooltip = this.contact.covidReplyRecd
                .fieldBool
                ? "Notification Email Acknowledged"
                : "Notification Email Not Acknowledged";
            if (this.contact.covidReplyRecd.updatedBy != "") {
                this.contact.covidReplyRecd.modifiedDate = moment
                    .utc(this.contact.covidReplyRecd.updatedDate)
                    .format("MM/DD/YYYY");
                this.contact.covidReplyRecd.tooltip =
                    this.contact.covidReplyRecd.tooltip +
                    (this.contact.covidReplyRecd.updatedBy
                        ? "\nAcknowledged By: " +
                          this.contact.covidReplyRecd.updatedBy +
                          " Acknowledged On: " +
                          this.contact.covidReplyRecd.modifiedDate
                        : "");
            }
            this.contact.covidReplyRecd.color = this.contact.covidReplyRecd
                .fieldBool
                ? "Green"
                : "Red";
        }
    }

    authorizeTabAccess() {
        const access = PermissionUtility.PermissionUtilities();
        const user = window.preload.user;
        _.forEach(this.tabs, function (tab, index) {
            tab.hasAccess = access.hasAccess(
                user,
                user.allFeatures,
                tab.authentication.split(","),
                null,
                null,
                null
            );
        });
    }

    go(route: string) {
        _.forEach(this.tabs, function (tab, index) {
            tab.active = false;
            if (tab.route === route) {
                tab.active = true;
            }
        });

        this._router.navigate([route], { relativeTo: this._activatedRoute });
    }

    activateSelectedTab() {
        const activatedRoute =
            this._activatedRoute.snapshot?.firstChild?.routeConfig?.path;
        if (activatedRoute) {
            _.forEach(this.tabs, (rt) => {
                rt.active = false;
                if (activatedRoute?.toLowerCase() === rt.route.toLowerCase()) {
                    rt.active = true;
                }
            });
        }
    }
    execute(fnDetails: any) {
        if (!_.isEmpty(fnDetails.methodName)) {
            switch (fnDetails.methodName) {
                case "loadContactDetails":
                    this.mode = fnDetails.mode;
                    this.preload.mode = this.mode;
                    this.loadContactDetails(false);
                    break;
            }
        }
    }

    setReadMode() {
        this.log.trace("setReadMode");
        this.contact = this.contactCopy;

        if (!this.editModeHRVerifiedSection) {
            this.contactCopy = {};
        }
        this.editMode = false;
    }

    loadSkills() {
        this._skillService.autocomplete(this.skillSearchTerm).subscribe({
            next: (result: any) => {
                this.skillData = result || [];
            },
            error: (err) => {
                this.log.showError(
                    "Unable to load skills at this time. Please try again later."
                );
            },
        });
    }

    setPositionEventTerm($event) {
        this.positionSearchTerm = $event;
    }

    positionTypeahead() {
        this.positionObservable$ = new Observable(
            (observer: Subscriber<string>) => {
                // Runs on every search
                observer.next(this.positionSearchTerm);
            }
        ).pipe(
            takeUntil(this.componentDestroyed$),
            switchMap((token: string) => {
                return this._positionService.autocomplete(token);
            })
        );
    }

    onPositionSelected(position) {
        this.log.trace(this.contact.positions);
        if (_.isEmpty(this.contact.positions)) {
            this.contact.positions = [];
        }

        this.contact.positions = position;
        this.positionSearchTerm = "";
    }

    onSkillSelected(skill) {
        this.log.trace(this.contact.skills);
        if (_.isEmpty(this.contact.skills)) {
            this.contact.skills = [];
        }
        this.contact.skills = skill;
        // this.contact.skills = (skill);

        this.skillSearchTerm = "";
    }

    setSkillEventTerm($event) {
        this.skillSearchTerm = $event;
        this.loadSkills();
    }

    ngOnInit() {
        this._dataService.setCss("contact");

        this._activatedRoute.params.subscribe((params) => {
            this.contactId = params["id"];
        });

        this._activatedRoute.queryParams.subscribe((qparams) => {
            this.preload.mode = qparams["mode"];
        });

        this._contactSharedData
            .getFnCall()
            .subscribe((fnDetails) => this.execute(fnDetails));

        this._contactSharedData.contactEditEnabled.subscribe((message) => {
            if (message) {
                this.setEditMode(true);
            } else {
                this.setReadMode();
            }
        });
        this._contactSharedData.contactEditUpdated.subscribe((res) => {
            this._contactSharedData.getContact().subscribe((res) => {
                this.contact = res;
                this.loadSkills();
            });
        });
        this._contactSharedData.HrVerficationEditEnabled.subscribe(
            (message) => {
                if (message) {
                    this.editModeHRVerifiedSection = message;
                }
            }
        );

        this.authorizeTabAccess();
        this.positionTypeahead();
        this.activateSelectedTab();
        this.loadContactDetails(true);
    }

    ngOnDestroy() {}
}
